import BlankSlate from './BlankSlate'

export { BlankSlate }
